import { Language } from '@/constants/currencyConfig';

const DISABLED_SK_PAGES = [
	'platba-skip-pay',
	'balicky',
	'css-program',
	'dobirka',
	'doporucte-nas',
	'dotaznik',
	'investuj-pri-nakupovani',
	'jak-zaplatit',
	'karta',
	'kariera',
	'kontokorent',
	'kreditni-karta',
	'kurzovni-listek',
	'mallpay',
	'nakup-na-splatky',
	'nakupujte-s-rozumem',
	'napsali-o-nas',
	'nase-produkty',
	'odlozena-platba',
	'odlozeni-splatnosti',
	'odmeny',
	'openapi',
	'platba-kartou',
	'platba-online',
	'platebni-brana',
	'pojisteni-ke-karte',
	'prevod-penez',
	'prodlouzena-zaruka',
	'pujcka',
	'pujcky',
	'recenze-klientu',
	'balicek-maxi',
	'uvitaci-video',
	'zruseni-skip-pay',
	'slevy/kategorie/[:category]',
	'slevy/[:eshop]',
	'slevy',
	'splatky',
	'srovnavac-produktu',
	'srovnavac-produktu/vyhledavani',
	'srovnavac-produktu/[:category]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]/[:subcategoryLevelFive]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]/[:subcategoryLevelFive]/[:subcategoryLevelSix]',
	'tiskove-zpravy',
	'tiskove-zpravy/[:pressRelease]',
	'zaplatim-po-vanocich',
	'my-to-platime',
	'pojisteni',
	'pojisteni/pojistne-podminky',
	'hlaseni-skody',
];

const DISABLED_HU_PAGES = [
	'platba-skip-pay',
	'balicky',
	'css-program',
	'dobirka',
	'doporucte-nas',
	'dotaznik',
	'investuj-pri-nakupovani',
	'jak-zaplatit',
	'karta',
	'kontokorent',
	'kreditni-karta',
	'kurzovni-listek',
	'mallpay',
	'nakup-na-splatky',
	'nakupujte-s-rozumem',
	'napsali-o-nas',
	'nase-produkty',
	'odlozena-platba',
	'odlozeni-splatnosti',
	'odmeny',
	'openapi',
	'platba-kartou',
	'platba-online',
	'platebni-brana',
	'pojisteni-ke-karte',
	'prevod-penez',
	'prodlouzena-zaruka',
	'pujcka',
	'pujcky',
	'recenze-klientu',
	'balicek-maxi',
	'uvitaci-video',
	'zruseni-skip-pay',
	'slevy/kategorie/[:category]',
	'slevy/[:eshop]',
	'slevy',
	'splatky',
	'srovnavac-produktu',
	'srovnavac-produktu/vyhledavani',
	'srovnavac-produktu/[:category]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]/[:subcategoryLevelFive]',
	'srovnavac-produktu/[:category]/[:subcategoryLevelOne]/[:subcategoryLevelTwo]/[:subcategoryLevelThree]/[:subcategoryLevelFour]/[:subcategoryLevelFive]/[:subcategoryLevelSix]',
	'tiskove-zpravy',
	'tiskove-zpravy/[:pressRelease]',
	'zaplatim-po-vanocich',
	'my-to-platime',
	'pojisteni',
	'pojisteni/pojistne-podminky',
	'hlaseni-skody',
	'kariera',
];

export function isAllowedRoute(route: string, locale?: Language): boolean {
	const currentLocale = locale || process.env.NEXT_PUBLIC_LANGUAGE;

	if (!currentLocale) {
		return false;
	}

	switch (currentLocale) {
		case 'sk':
			return !DISABLED_SK_PAGES.includes(route);
		case 'hu':
			return !DISABLED_HU_PAGES.includes(route);
		default:
			return true;
	}
}
